module.exports = "/call-frontend/img/empty.99cefdb7.png";